var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59218 5L9.6648 1.94444C10.1117 1.5 10.1117 0.833333 9.6648 0.388889C9.49721 0.166667 9.21788 0 8.93855 0C8.65922 0 8.37989 0.111111 8.15643 0.333333L5.02793 3.44444L1.95531 0.388889C1.50838 -0.0555557 0.782123 -0.0555557 0.391061 0.388889C0.167598 0.555555 0 0.833334 0 1.16667C0 1.5 0.111732 1.72222 0.335196 1.94444L3.40782 5L0.335196 8.05556C0.167598 8.27778 0 8.55556 0 8.88889C0 9.16667 0.111732 9.44444 0.335196 9.66667C0.558659 9.88889 0.837989 10 1.11732 10C1.39665 10 1.67598 9.88889 1.89944 9.66667L4.97207 6.61111L8.04469 9.66667C8.49162 10.1111 9.21788 10.1111 9.60894 9.66667C10.0559 9.22222 10.0559 8.5 9.60894 8.11111L6.59218 5Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fdf049f2d52480ec4cecfc58534cea69.svg";
export { ForwardRef as ReactComponent };